import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewChecked, ChangeDetectorRef, Component, Inject, NgZone, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import {
    ApiError,
    ApiRequestService,
    GoogleTagManagerService,
    MAT_ICON,
    TOAST_STATE,
    ToastmessageService
} from '@prekog/common-ui';
import { catchError, throwError } from 'rxjs';
import { Speciality } from '../consultation/speciality';
import { Doctor } from '../doctor';
import { DoctorConsultingHour } from './doctorconsultinghour';
import { FIndConsultingHoursRequest } from './findConsultingHoursRequest';
import { FindConsultingHoursResponse } from './findConsultingHoursResponse';
import { FindDoctorRequest } from './finddoctorrequest';
import { FindDoctorResponse } from './finddoctorresponse';
import { GetDoctorSpecialitiesRequest } from './getdoctorspecialitiesrequest';
import { GetDoctorSpecialitiesResponse } from './getdoctorspecialitiesresponse';
import { IframeUrlPipe } from './iframeurlpipe';

@Component({
    selector: 'pf-doctor',
    templateUrl: './doctor.component.html',
    styleUrls: ['./doctor.component.scss'],
    standalone: true,
    imports: [IframeUrlPipe, CommonModule]
})
export class DoctorComponent implements OnInit, AfterViewChecked {
    doctor: Doctor = {};

    doctorConsultingHoursList: DoctorConsultingHour[] = [];
    downloadFileUrl = '';
    event = 'Orvos megtekintése';
    findAllConsultingHoursUrl = '/regenero/find-consulting-hour';
    findDoctorUrl = '/regenero/find-doctor-by-routerlink';

    getSpecialitiesForADoctorUrl = '/regenero/get-doctor-specialities';

    regeneroBaseUrl = '';

    routerLink = '';

    specialities?: Speciality[];

    constructor(
        public router: Router,
        private _apiRequestService: ApiRequestService,
        @Inject('DOWNLOAD_FILE_URL') private _downloadFileUrl: string,
        @Inject('REGENERO_BASE_URL') private _regeneroBaseUrl: string,
        private _toastMessageService: ToastmessageService,
        private ref: ChangeDetectorRef,
        private ngZone: NgZone,
        private readonly _domSanitizer: DomSanitizer,
        private _googleTagManagerService: GoogleTagManagerService
    ) {
        this.downloadFileUrl = _downloadFileUrl;
        this.regeneroBaseUrl = _regeneroBaseUrl;
    }
    ngAfterViewChecked(): void {
        this.ngZone.runOutsideAngular(() => {
            this.ref.detectChanges();
            setTimeout(() => {
                const lastSegmentOfUrl = window.location.href.split('/').pop();
                const routerLink = lastSegmentOfUrl as string;
                if (this.routerLink !== routerLink) {
                    window.location.reload();
                }
            }, 0);
        });
    }
    ngOnInit(): void {
        const fullUrl = window.location.href;
        this.routerLink = fullUrl.split('/').pop()?.split('?')[0] || '';
        const findDoctorRequest: FindDoctorRequest = {
            routerLink: this.routerLink
        };

        this._apiRequestService
            .sendRequest<FindDoctorRequest, FindDoctorResponse>(this.regeneroBaseUrl, findDoctorRequest, true, this.findDoctorUrl)
            .subscribe((response) => {
                this.doctor = response.doctor!;
                this.doctor.introduction = this._domSanitizer.bypassSecurityTrustHtml(this.doctor.introduction!) as string;
                this.getConsultingHours(this.doctor.id!);
                this.ngZone.runOutsideAngular(() => {
                    setTimeout(() => {
                        this._googleTagManagerService.viewCustomObject(this.event, this.doctor.name!);
                    }, 0);
                });
            });
    }

    getConsultingHours(id: number) {
        const findConsultingHoursRequest: FIndConsultingHoursRequest = {
            doctorId: id
        };

        this._apiRequestService
            .sendRequest<FIndConsultingHoursRequest, FindConsultingHoursResponse>(
                this.regeneroBaseUrl,
                findConsultingHoursRequest,
                true,
                this.findAllConsultingHoursUrl
            )
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const apiError: ApiError = error.error as ApiError;

                        this._toastMessageService.displayToastMessage(TOAST_STATE.error, 'HttpError hiba!', MAT_ICON.error);
                        this.dismissError();

                        this.router.navigateByUrl('/');
                    });
                })
            )
            .subscribe((response: FindConsultingHoursResponse) => {
                this.doctorConsultingHoursList = response.doctorConsultingHourList!;
                this.getSpecialitiesForDoctor(id);
            });
    }

    getSpecialitiesForDoctor(id: number) {
        const getSpecialitiesDoctorRequest: GetDoctorSpecialitiesRequest = {
            doctorId: id
        };

        this._apiRequestService
            .sendRequest<
                GetDoctorSpecialitiesRequest,
                GetDoctorSpecialitiesResponse
            >(this.regeneroBaseUrl, getSpecialitiesDoctorRequest, true, this.getSpecialitiesForADoctorUrl)
            .subscribe((response) => {
                this.specialities = response.specialityList!;
            });
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }
}
